/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { IAutenticacaoResposta } from 'Models/auth'
import IRenovacaoToken from 'Models/auth/IRenovacaoToken'
import ApiService from 'Services/ApiService'

const autenticacao = {
  login: async (
    login: string,
    senha: string,
    lembrarMe: boolean,
    idComponente?: number,
  ): Promise<AxiosResponse<IAutenticacaoResposta>> =>
    await ApiService({
      idComponente,
    }).post<IAutenticacaoResposta>(`${hosts.WS_DOCAS}/autenticacao`, {
      login,
      senha,
      lembrarMe,
    }),

  buscaDados: async (
    idComponente?: number,
  ): Promise<AxiosResponse<IAutenticacaoResposta>> =>
    await ApiService({
      idComponente,
    }).get<IAutenticacaoResposta>(`${hosts.WS_DOCAS}/autenticacao`),
}

export default autenticacao
